var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('home-layout',[_c('v-card',[_c('v-card-title',[_c('h1',[_vm._v("Currency Converter")])]),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"blue","dark":""},on:{"click":function($event){_vm.$router.push('/currencies')}}},[_vm._v("\n        List of currencies\n      ")])],1)],1),_vm._v(" "),_c('convert-box')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-829ade38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = null
// module chunks = 